export default __webpack_public_path__ + "static/media/file_download.a05535a3.png";